import SubscribeForm from '@/components/feature/SubscribeForm';

export default function SubscribeSection() {
  return (
    <section id="subscribe" className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-100/60 border-t border-background-200">
      <div className="rounded-lg border border-background-200 bg-background-50 overflow-hidden grid grid-cols-1 lg:grid-cols-2">
        <div className="p-6 md:p-10 flex flex-col justify-center">
          <span className="inline-flex items-center gap-2 text-xs font-label tracking-widest uppercase text-accent-600 mb-3">
            <span className="w-6 h-px bg-accent-400"></span>
            订阅提醒
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-snug">
            新清单发布时，
            <br />
            收到一封简短提醒
          </h2>
          <p className="mt-3 text-sm text-foreground-600 leading-relaxed font-body">
            只发真正有用的更新，不发广告。你可以随时取消订阅，不会打扰你。
          </p>
          <div className="mt-6">
            <SubscribeForm />
          </div>
        </div>
        <div className="relative min-h-[220px] lg:min-h-full">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20still%20life%20of%20a%20notebook%2C%20pen%20and%20coffee%20cup%20on%20a%20cream%20desk%20with%20soft%20window%20light%2C%20amber%20and%20beige%20tones%2C%20minimal%20editorial%20photography%2C%20cozy%20calm%20mood&width=800&height=800&seq=subscribe-kanliao-note&orientation=squarish"
            alt="订阅看料避雷社 避雷清单更新提醒"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
        </div>
      </div>
    </section>
  );
}